import { Attachment } from '@shared/models';
import { SanityDocument } from '../../../types';

export const isSanityDocument = (
  document: Attachment | SanityDocument,
): document is SanityDocument => {
  return (document as SanityDocument).id !== undefined;
};
